import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body pt-10" }

import { isMobile } from "@/core/config/WindowConfig";
import ProductsCheck from "../components/ProductsCheck.vue";
import ProductRegister from "../components/ProductRegister.vue";
import { ref, provide } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsIndex',
  setup(__props) {

const mainStep = ref(0);
const selectedAccountTypes = ref<any>([]);
const selectedVerification = ref<any>([]);
const verificationData = ref<any>([]);

provide("verificationData", verificationData);
provide("selectedVerification", selectedVerification);
provide("mainStep", mainStep);
provide("selectedAccountTypes", selectedAccountTypes);

return (_ctx: any,_cache: any) => {
  return (mainStep.value == 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["card", { 'pt-5': !_unref(isMobile), 'mt-10': !_unref(isMobile) }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ProductsCheck)
        ])
      ], 2))
    : (mainStep.value == 1)
      ? (_openBlock(), _createBlock(ProductRegister, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})